import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Juridiction, EntityType } from '../entity.types';
import { EntityRestrictedList } from './components/EntityRestrictedList';
import { EntityInfos } from './infos/EntityInfos';
import { EntityBlockLine } from './components/EntityBlockLine';
import { buildJurisdictionUrl } from '../charts/juridictions/juridictionChart.utils';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../components/EntityBlockComponents';
import { EntityBlockContentHeader } from '../components/EntityBlockContentComponents';

type Props = {
  casesByJurisdiction: Array<Juridiction>;
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
  dontShowHref?: boolean;
};

export const EntityCasesByJurisdiction: FC<Props> = ({
  casesByJurisdiction,
  decisionCount,
  entityType,
  entityId,
  entityName,
  dontShowHref,
}) => {
  const restrictedDisplayLimit = 5;

  const source = 'expertise_jurisdiction';

  return (
    <EntityBlock>
      <EntityBlockTitle>
        <FormattedMessage id="entity/expertises/CasesByJurisdiction.tsx/1" />
      </EntityBlockTitle>
      <EntityInfos
        decisionCount={decisionCount}
        entityType={entityType}
        lawyerId={entityId}
        entityName={entityName}
      />
      <EntityBlockContentHeader>
        <span>
          <FormattedMessage id="entity/expertises/CasesByJurisdiction.tsx/2" />
        </span>
        <span>
          <FormattedMessage id="entity/expertises/CasesByJurisdiction.tsx/3" />
        </span>
      </EntityBlockContentHeader>
      <EntityRestrictedList
        list={casesByJurisdiction}
        limit={restrictedDisplayLimit}
        source={source}
      >
        {(newCasesByJurisdiction) =>
          newCasesByJurisdiction.map((jurisdiction) => {
            const url = buildJurisdictionUrl({
              entityType,
              entityIdUrlArg: entityId,
              entityName,
              juridictionKey: jurisdiction.key,
            });

            return (
              <EntityBlockLine
                data-test-id={jurisdiction.key}
                key={jurisdiction.key}
                label={jurisdiction.name}
                value={jurisdiction.count}
                url={dontShowHref ? undefined : url}
                source={source}
              />
            );
          })
        }
      </EntityRestrictedList>
    </EntityBlock>
  );
};
